import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function CallBack(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.315 6.74a3.95 3.95 0 013.946-3.947 3.95 3.95 0 013.946 3.946 3.95 3.95 0 01-3.946 3.946 3.95 3.95 0 01-3.946-3.946zm-1.793 0a5.746 5.746 0 005.739 5.738A5.746 5.746 0 0023 6.74 5.746 5.746 0 0017.26 1a5.746 5.746 0 00-5.738 5.74zm-5.936 6.555C3.99 10.928 2.213 7.038 3.205 5.727l1.54-1.55a.96.96 0 011.363 0l1.362 1.37a.968.968 0 01.283.686c0 .26-.1.502-.283.686L6.45 7.947a.969.969 0 00-.264.872c.045.236 1.21 5.805 8.346 8.934a.964.964 0 001.066-.204l1.917-1.927a.917.917 0 01.33-.168c.067.005.205.093.408.37.185.23.392.462.603.698l.014.016.011.012c.432.484.879.983 1.114 1.465.146.297.155.603.122.647l-1.945 1.956c-.634.636-1.878.579-3.806-.181-1.533-.603-3.06-1.501-4.535-2.67a22.36 22.36 0 01-4.244-4.472zm8.078 8.947c.647.255 1.925.758 3.24.758.927 0 1.872-.25 2.63-1.012l1.995-2.011c.608-.713.684-1.82.193-2.82-.355-.725-.92-1.358-1.421-1.916l-.023-.026a18.326 18.326 0 01-.5-.57c-.631-.878-1.338-1.097-1.82-1.125-1.054-.083-1.779.7-1.833.76l-1.417 1.424c-4.62-2.239-6.097-5.558-6.5-6.786l.625-.628a2.923 2.923 0 000-4.113L7.47 2.807a2.88 2.88 0 00-4.087 0l-1.58 1.588a1.087 1.087 0 00-.063.07C-.575 7.3 3.21 13.224 4.007 14.406a24.283 24.283 0 004.63 4.884c1.625 1.286 3.317 2.28 5.027 2.952zm4.494-18.014v1.614l-.897 1.794a.897.897 0 01-.897-.897V4.23a.897.897 0 011.794 0zm0 1.614l-.895 1.794h2.509a.897.897 0 100-1.794h-1.614z",
    fill: props.color || "#222"
  }));
}
var MemoCallBack = React.memo(CallBack);
export default MemoCallBack;